import { render } from "./totalChart.vue?vue&type=template&id=801de766&scoped=true&ts=true"
import script from "./totalChart.vue?vue&type=script&lang=ts&config=true"
export * from "./totalChart.vue?vue&type=script&lang=ts&config=true"

import "./totalChart.vue?vue&type=style&index=0&id=801de766&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801de766"]])

export default __exports__